"use client";

import { useEffect, useState } from "react";

type ConsentLevel = string;

export default function useCookieConsent() {
  const [consent, setConsent] = useState<ConsentLevel>("");

  // Read cookie on first load
  useEffect(() => {
    const match = document.cookie.match(/cookie_consent=([^;]+)/);
    if (match) setConsent(match[1]);
  }, []);

  // Helper: update consent cookie and local state
  const updateConsent = (value: ConsentLevel) => {
    document.cookie = `cookie_consent=${value}; path=/; max-age=${
      60 * 60 * 24 * 365
    }; SameSite=Lax`;

    setConsent(value);
    const categories = value.split(",").map((x) => x.trim());

    const consentState = {
      essential: categories.includes("essential"),
      functional: categories.includes("functional"),
      analytics: categories.includes("analytics"),
      marketing: categories.includes("marketing"),
    };

    (window as any) .dataLayer.push({
      event: "cookie_consent_update",
      cookie_consent: consentState,
    });

    window.dispatchEvent(new Event("cookieConsentUpdated"));
  };

  // Optional: re-check consent when cookie changes in another tab
  useEffect(() => {
    const listener = () => {
      const match = document.cookie.match(/cookie_consent=([^;]+)/);
      setConsent(match ? match[1] : "");
    };
    window.addEventListener("cookieConsentUpdated", listener);
    window.addEventListener("focus", listener); // recheck on tab refocus
    return () => {
      window.removeEventListener("cookieConsentUpdated", listener);
      window.removeEventListener("focus", listener);
    };
  }, []);

  return {
    consent,
    hasConsented: consent !== "" && consent != null,
    updateConsent,
  };
}
